.scrollContainer {
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-color: #eaecf0 transparent;
    scrollbar-width: thin;
}

// CSS Grid gives each row the height of its tallest card automatically — no JS
// measuring needed. Default to 3 columns; drop to 2 then 1 only on narrower
// viewports where 3 tiles no longer fit comfortably.
.grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    padding-bottom: 15px;

    @media (max-width: 1140px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
}
